import React, { useCallback } from "react"
import { RelendModal } from "@/components/relendModal"
import { useAtom } from "jotai"
import { appNFTRewardModalRewardState } from "@/atoms/appPopupState"
import useLocalStorage from "@/hooks/useLocalStorage"
import useTrans from "@/hooks/useTrans"
import DogClaimImage from "@/assets/images/dog-cute-claim.png"
import GifBoxRewardImage from "@/assets/images/gif-box-reward.png"
import Image from "next/image"
import { Stack, Typography } from "@mui/material"
import Button from "@/components/base/Button"

const View = ({ handleGetItNow }: { handleGetItNow: () => void }) => {
  const trans = useTrans()
  const [popupState, setPopupState] = useAtom(appNFTRewardModalRewardState)
  const [, setIsLaterClaimNFTReward] = useLocalStorage("isLaterClaimNFTReward", false)

  const handleCloseModal = useCallback(() => {
    setPopupState((prev) => ({
      ...prev,
      isOpen: false,
    }))

    setIsLaterClaimNFTReward(true)
  }, [setPopupState, setIsLaterClaimNFTReward])

  return (
    <RelendModal
      open={popupState.isOpen}
      handleClose={handleCloseModal}
      textButtonClose={trans.dashboard.modal.claim_later}
      data-testid='modal-nft-reward'
    >
      <Stack className='pt-10' alignItems='center' gap={2}>
        <Image src={GifBoxRewardImage} className='absolute top-0 m-auto' alt='gif-box-reward' height={241} />

        <Image src={DogClaimImage} alt='doge-question' width={188} />

        <Typography className='text-center text-neutral-1000 font-bold sm:text-2xl'>
          {trans.dashboard.modal.exclusive_gift_for_you}
        </Typography>
        <Typography className='text-center text-neutral-900 sm:text-base'>
          {trans.dashboard.modal.exclusive_gift_for_you_desc}
        </Typography>

        <Button
          data-testid='btn-get-reward-nft-now'
          fullWidth
          variant='primary'
          size='lg'
          onClick={handleGetItNow}
          className='mt-4'
        >
          {trans.dashboard.modal.get_it_now}
        </Button>
      </Stack>
    </RelendModal>
  )
}

export default View
